import { connect } from 'react-redux';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { ONLINE_CHECK_IN } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import ProductLayout from '../../common/main-layout/ProductLayout';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import ViLayout from '../../common/components/vi-layout/ViLayout';
import ViSmallCardLayout from '../../common/components/vi-small-card-layout/ViSmallCardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  VI: VI_CARD_LAYOUT,
  VISmall: VI_SMALL_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = ONLINE_CHECK_IN;
const sharedTexts = {
  persuasionContent: 'onlineCheckInPersuasionContent',
  readMoreContent: 'onlineCheckInReadMoreModalContent',
  title: 'onlineCheckInTitle',
  viReadMoreText: 'onlineCheckInViReadMoreText',
  viPromotionalPill: 'onlineCheckInViPromotionalPill'
};
const mainCardTranslations = {
  ...sharedTexts,
  upSell: 'onlineCheckInUpSellText',
  additionalInformation: 'onlineCheckInAdditionalInformation',
  abstractContent: 'onlineCheckInAbstract'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [ProductCardLayoutType.PostBooking]: mainCardTranslations,
  [VI_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'onlineCheckInAbstractSmallCard',
    upSell: 'onlineCheckInUpSellTextSmallCard'
  },
  [VI_SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'onlineCheckInAbstractSmallCard',
    upSell: 'onlineCheckInUpSellTextSmallCard'
  }
};
const OnlineCheckIn = ({
  className,
  form,
  isSelected,
  productCode,
  productPosition,
  order,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case VI_SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(ViSmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case VI_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(ViLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(PRODUCT_NAME, form)(state)
});
export default connect(mapStateToProps)(OnlineCheckIn);
//# sourceMappingURL=OnlineCheckIn.js.map